/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PaceAnalysisBenchmarkProgressAtCurrentDay } from './paceAnalysisBenchmarkProgressAtCurrentDay';

export interface PaceAnalysis {
  /** Days since student started the module */
  currentModuleDay: number;
  /** Expected progress at current module day */
  benchmarkProgressAtCurrentDay: PaceAnalysisBenchmarkProgressAtCurrentDay;
  /** Days behind/ahead of benchmark (negative = ahead) */
  daysBehindBenchmark?: number;
  /** Recent progress trend: accelerating|steady|slowing|stalled */
  trajectory: string;
  /** Whether intervention is recommended */
  interventionRecommended?: boolean;
}
